export default __webpack_public_path__ + "static/media/032-money.e964a2e2.svg";